import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import useApi from "$src/core/hooks/use-api";
import { queryKey as subscriptionOffersQueryKey } from "$src/core/queries/use-subscription-offers-query";
import { queryKey as subscriptionsQueryKey } from "$src/core/queries/use-subscription-query";

const MUTATION_KEY = ["subscription-offer-switch"];

type Variables = {
  type: "upgrade" | "downgrade";
  offerId: string;
  toOfferId: string;
  coupon?: string;
};

const useSubscriptionOfferSwitchMutation = () => {
  const queryClient = useQueryClient();
  const { api } = useApi();

  const mutationFn = useCallback(
    ({ type, offerId, toOfferId, coupon }: Variables) =>
      api.switchSubscriptionOffer(type, offerId, toOfferId, coupon),
    [api],
  );

  return useMutation({
    mutationKey: MUTATION_KEY,
    mutationFn,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: subscriptionOffersQueryKey(),
        }),
        queryClient.invalidateQueries({
          queryKey: subscriptionsQueryKey(),
        }),
      ]);
    },
  });
};

export default useSubscriptionOfferSwitchMutation;
